import React, { Component } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Container,
  CardHeader,
} from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import { strings } from "../../localization/Subscriptions";
import { API_URL, Language } from "../../config";
import { Link } from "react-router-dom";

const PAGE_LIMIT = 5;

class PlanHistory extends Component {
  constructor(props) {
    super(props);
    strings.setLanguage(Language);

    this.state = {
      organisationId: "",
      planHistory: [],
      historyLoading: false,
      currentPage: 1,
      skip: 0,
      next: false,
      prev: true,
      orgName: "",
    };
  }

  componentDidMount() {
    const orgId = this.props.match.params.id;
    if (orgId) {
      this.setState({ organisationId: orgId }, () => {
        this.getPlanHistory(0);
      });
    }
  }

  getPlanHistory(skip = 0) {
    this.setState({ historyLoading: true });
    const { organisationId } = this.state;
    fetch(
      `${API_URL}plan-pricing/history?organisation_id=${organisationId}&limit=${PAGE_LIMIT}&skip=${skip}`,
      {
        method: "GET",
        credentials: "include",
      }
    )
      .then((res) => res.json())
      .then((res) => {
        let orgName = "";
        if (res.result && res.result.length > 0) {
          orgName = res.result[0].data.organisationName || "";
        }
        // If result length is less than limit, next should be true (disable next)
        this.setState({
          planHistory: res.result || [],
          historyLoading: false,
          skip,
          currentPage: Math.floor(skip / PAGE_LIMIT) + 1,
          next: res.result.length !== PAGE_LIMIT,
          prev: skip === 0,
          orgName,
        });
      })
      .catch(() => {
        this.setState({ historyLoading: false });
      });
  }

  pageIncrement() {
    if (!this.state.next) {
      let skip = this.state.currentPage * PAGE_LIMIT;
      this.getPlanHistory(skip);
      this.setState({
        currentPage: this.state.currentPage + 1,
        prev: false,
        skip: skip,
      });
    }
  }

  pageDecrement() {
    if (this.state.skip > 0) {
      let skip = this.state.skip - PAGE_LIMIT;
      if (skip >= 0) {
        this.getPlanHistory(skip);
        if (skip === 0) {
          this.setState({
            prev: true,
          });
        }
        this.setState({
          currentPage: this.state.currentPage - 1,
          next: false,
          skip: skip,
        });
      } else {
        this.setState({
          prev: true,
          next: false,
        });
      }
    } else {
      this.setState({
        next: false,
      });
    }
  }

  render() {
    return (
      <Container fluid className="main-content-container px-4">
        <Row noGutters className="page-header py-4">
          <Col>
            <PageTitle
              title={this.state.orgName || "Plan History"}
            //   title={strings.plan_history || "Plan History"}
              subtitle={strings.plan_history}
              md="12"
              className="ml-sm-auto mr-sm-auto"
            />
          </Col>
          <Col style={{ display: "flex", justifyContent: "flex-end" }}>
            <Link to={"/subscriptions"} className="float-left">
              <Button size="sm" theme="light" className="mb-2 mr-1">
                {strings.go_back || "Go Back"}
              </Button>
            </Link>
          </Col>
        </Row>

        <Row>
          <Col lg="12" md="12" sm="12">
            <Card small className="mb-4">
              <CardHeader className="border-bottom">
                <h6 className="m-0">
                  {strings.payment_history || "Payment History"}
                </h6>
              </CardHeader>
              <CardBody>
                {this.state.historyLoading ? (
                  <div className="text-center py-4">
                    <div
                      className="spinner-border text-primary mb-2"
                      role="status"
                      style={{ width: "2rem", height: "2rem" }}
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                    <p className="mb-0 text-muted">
                      {strings.fetching_plan_history ||
                        "Fetching plan history..."}
                    </p>
                  </div>
                ) : this.state.planHistory.length > 0 ? (
                  <>
                    <div className="table-responsive">
                      <table className="table table-striped table-bordered table-hover">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>{strings.plan || "Plan"}</th>
                            <th>{strings.amount || "Amount"}</th>
                            <th>{strings.start_date || "Satrt Date"}</th>
                            <th>
                              {strings.end_date || "End Date"}
                            </th>
                            <th>{strings.payment_mode || "Payment Mode"}</th>
                            <th>
                              {strings.payment_method || "Payment Method"}
                            </th>
                            <th>{strings.payment_id || "Payment ID"}</th>
                            <th>{strings.status || "Status"}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.planHistory.map((item, idx) => (
                            <tr key={item._id}>
                              <td>{this.state.skip + idx + 1}</td>
                              <td>{item.data.planName || "-"}</td>
                              <td>{item.data.amount || "-"}</td>
                              <td>
                                {item.data.plan_start_date
                                  ? new Date(
                                      item.data.plan_start_date,
                                    ).toLocaleDateString()
                                  : "-"}
                              </td>
                              <td>
                                {item.data.plan_end_date
                                  ? new Date(
                                      item.data.plan_end_date,
                                    ).toLocaleDateString()
                                  : "-"}
                              </td>
                              <td>{item.data.paymentMode || "-"}</td>
                              <td>
                                {(item.data.request_data &&
                                  item.data.request_data.payment_method) ||
                                  item.data.payment_method ||
                                  "-"}
                              </td>
                              <td style={{ wordBreak: "break-all" }}>
                                {(item.data.request_data &&
                                  item.data.request_data.order_id) ||
                                  "-"}
                              </td>
                              <td>
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    backgroundColor: "#f0fdf4",
                                    color: "#16a34a",
                                    padding: "2px 10px",
                                    borderRadius: "20px",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                  }}
                                >
                                  <i
                                    className="material-icons"
                                    style={{
                                      fontSize: "16px",
                                      marginRight: "4px",
                                      display: "flex",
                                      alignItems: "center",
                                      position: "unset",
                                    }}
                                  >
                                    check_circle
                                  </i>
                                  {item.data.status || "-"}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <nav className="d-flex justify-content-center align-items-center">
                      <ul className="pagination">
                        <li className="page-item">
                          <button
                            type="button"
                            className="page-link"
                            onClick={() => this.pageDecrement()}
                            style={
                              this.state.prev
                                ? { cursor: "not-allowed", color: "gray" }
                                : null
                            }
                            disabled={this.state.prev}
                          >
                            {strings.previous || "Previous"}
                          </button>
                        </li>
                        <li className="page-item">
                          <button
                            type="button"
                            className="page-link"
                            onClick={() => this.pageIncrement()}
                            style={
                              this.state.next
                                ? { cursor: "not-allowed", color: "gray" }
                                : null
                            }
                            disabled={this.state.next}
                          >
                            {strings.next || "Next"}
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </>
                ) : (
                  <p className="text-center">
                    {strings.no_history_available || "No history available"}
                  </p>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default PlanHistory;
